﻿(function ($) {

    //Attach this new method to jQuery
    $.fn.extend({

        //This is where you write your plugin's name
        OneSearch: function (options) {

            //Set the default values, use comma to separate the settings, example:
            var _defaults = {
                ServiceUrl: '',
                OneSearchName: '',
                OneSearchDS: null,
                MinCharLimit: 3,
                EnableCurrentLocation: false,
                EnablePreList: false,
                AutoSelectFirstItem: false,
                ResultLimit: 10,
                EnableTouch: false,
                DataSource: null,
                DataSourceControl: null,
                ContainerCss: '',
                ItemCss: '',
                HighlightItemCss: '',
                Region: 'US',
                Locale: 'NONE',
                HelpText: '',
                AnimatePlaceholderText: false,
                MultiSelect: false,
                MultiSelectBoxId: '',
                MultiSelectShowHelpText: true,
                MultiKeywordDelimiter: '',
                LoadingImageUrl: '',
                ParentContainer: '',
                BeforeCall: null,
                AfterCall: null,
                OnSuccess: null,
                OnError: null,
                OnSelect: null,
                OnTextChange: null,
                OnSearch: null,
                OnIncrementalSearch: null,
                OnMultiSelectRemove: null,
                SearchMode: 'Database', // Cache, Database, Smart
                TestMode: false,
                StickyMode: false,
                EnableCategoryView: false
            }

            var _options = $.extend(_defaults, options);
            var _targetControl = null;
            var _targetAutoControl = null;
            var _oneSearchBox = null;
            var _MultiSelectBox = null;

            var _lastKeyword = '';
            var _lastSearchword = '';

            var _request = null;
            var _resposeCache = null;
            var _itemTeplateCache = [];
            var _highlightIdx = 0;

            var _isOnArrowSelection = false;
            var _isLocationSerachEnabled = false;

            //Iterate over the current set of matched elements
            return this.each(function () {
                Init($(this));
            });

            function Init(obj) {
                if (_options.StickyMode && !_options.TestMode) _options.TestMode = true;

                _targetControl = obj;

                if (_options.AutoSelectFirstItem) {
                    _targetAutoControl = $('input[id="' + $(_targetControl).attr('id') + '_AUTO_ITEM"]')
                }

                // disable browser autocomplete on input
                // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
                $(_targetControl).attr('autocomplete', 'nope');
                $(_targetControl).attr('name', $(_targetControl).attr('id').replace(/\$/gi, '_') + (new Date()).valueOf());
                window.onpopstate = function (event) {
                    $(_targetControl).attr('name', $(_targetControl).attr('id').replace(/\$/gi, '_') + (new Date()).valueOf());
                };
                _oneSearchBox = $('<div>')
                    .attr('id', $(_targetControl).attr('id') + '_OneSearch')
                    .css('position', (_options.EnableTouch ? 'relative' : 'absolute'))
                    .css('top', getTotalHeightOfControl($(_targetControl)))
                    .css('width', getTotalWidthOfControl($(_targetControl)))
                    .css('display', 'none')
                    .addClass(_options.ContainerCss)
                    .html(_options.HelpText);

                if (_options.ParentContainer != '') {
                    $('#' + _options.ParentContainer).append(_oneSearchBox);
                } else {
                    _oneSearchBox.insertAfter($(_targetControl));
                }

                $(_targetControl).closest('div').click(function (e) {
                    if ($(_targetControl).css('display') == 'block' && $(_targetControl).html() != '') return;
                    if (e.target.className == 'CloseArea') return;
                    //MdlReloadControlState($(this), $(this).closest('[data-search]'));
                    if (!_options.EnablePreList) {
                        setTimeout(function () {
                            $(_targetControl).focus();
                        }, 500);
                    }
                });

                if (_options.MultiSelect) {
                    if (_options.MultiSelectBoxId != '') {
                        _MultiSelectBox = $('#' + _options.MultiSelectBoxId)
                    }
                    if (_MultiSelectBox != null && _options.MultiSelectBoxCss != '') {
                        _MultiSelectBox.addClass(_options.MultiSelectBoxCss);
                    }

                    reloadMultiSelectOnLoad();
                }
                else {
                    reloadSingleSelectOnLoadForDatalookup();
                }

                //check is location search enabled
                if (_options.EnableCurrentLocation) {
                    var lat = $('input[type="hidden"][id="' + $(_targetControl).attr('id') + '_GPS_RLAT"]').val();
                    var lng = $('input[type="hidden"][id="' + $(_targetControl).attr('id') + '_GPS_RLONG"]').val();
                    var rds = $('input[type="hidden"][id="' + $(_targetControl).attr('id') + '_GPS_RDS"]').val();
                    if (typeof (lat) != 'undefined' && typeof (lng) != 'undefined' && typeof (rds) != 'undefined' && lat != '' && lng != '' && rds != '') {
                        _isLocationSerachEnabled = true;
                    }
                }
                $(_targetControl).keydown(function (e) {
                    switch (e.keyCode) {
                        case 9 /* tab */:
                        case 13 /* enter */:
                            if (_options.AutoSelectFirstItem && $(_targetControl).val().length > 0) {
                                if (_highlightIdx > 0) selectHighlightedItem(); else {
                                    selectItem(0, false, true);
                                }
                                _isOnArrowSelection = false;
                            } else {
                                selectHighlightedItem();
                                _isOnArrowSelection = false;
                            }
                            break;
                            //case 37 /* left */:

                            //    break;
                        case 38 /* up */:
                            highlightItem(-1);
                            break;
                        case 39 /* right */:
                            if (_options.AutoSelectFirstItem) {
                                selectItem(0, false, true);
                                $(_oneSearchBox).hide();
                                $(_targetAutoControl).val('');
                            }
                            break;
                        case 40 /* down */:
                            highlightItem(1);
                            break;
                        case 27 /* escape */:
                            $(_oneSearchBox).hide();
                            _resposeCache = null;
                            _itemTeplateCache = [];
                            _highlightIdx = 0;
                            break;
                        default:
                            break;
                    }
                });

                $(_targetControl).keypress(function (e) {
                    if (parseInt(_oneSearchBox.css('width')) != getTotalWidthOfControl($(_targetControl))) {
                        _oneSearchBox.css('width', getTotalWidthOfControl($(_targetControl)));
                    }
                    if (parseInt(_oneSearchBox.css('top')) != getTotalHeightOfControl($(_targetControl))) {
                        _oneSearchBox.css('top', getTotalHeightOfControl($(_targetControl)));
                    }

                    if (e.keyCode == 13) e.preventDefault();
                });

                $(_targetControl).keyup(function (e) {
                    if (e.keyCode == 27) return;

                    if ((e.keyCode == 8 || e.keyCode == 46 || e.keyCode == 88 || e.keyCode == 86) && $(_targetControl).val().length == 0) {
                        bindAssociateControl(null, null);
                        if (_options.AutoSelectFirstItem) _targetAutoControl.val('');
                    }

                    //if (e.keyCode == 13 && $(_targetControl).val().length > 0 && $(_oneSearchBox).css('display') == 'none') {
                    //    if (_options.OnSearch) _options.OnSearch();
                    //}
                    if (e.keyCode == 13 && $(_targetControl).val().length > 0 && !_isOnArrowSelection) {
                        if (_options.OnSearch) _options.OnSearch();
                    } else if (e.keyCode == 13 && $(_targetControl).val().length > 0 && _options.AutoSelectFirstItem) {
                        if (_highlightIdx > 0) selectHighlightedItem(); else {
                            selectItem(0, false, true);
                        }
                    } else if (_options.OnIncrementalSearch) {
                        _options.OnIncrementalSearch();
                    }

                    if ($(_targetControl).val().length >= _options.MinCharLimit || _options.EnablePreList || _options.EnableCurrentLocation) $(_oneSearchBox).show(); else $(_oneSearchBox).hide();

                    if (e.keyCode == 13) $(_oneSearchBox).hide();

                    if ($(_targetControl).val().indexOf(_lastKeyword) < 0) {
                        $(_oneSearchBox).html('');
                    }

                    if (e.keyCode == 8 || e.keyCode == 46) {
                        _lastKeyword = '';
                        _lastSearchword = '';
                    }

                    // If there is no change the last and current value in the keyword, then no need to continue
                    if (_lastKeyword == $(_targetControl).val()) return;

                    if (_options.OnTextChange) _options.OnTextChange($(_targetControl).val());

                    // Clear associated controls since the keyword has been changed
                    bindAssociateControl(null, null);

                    // set current value of the text boox as last value/keyword
                    _lastKeyword = $(_targetControl).val();

                    // if the suggestion box is hidden then no need to continue
                    if ($(_oneSearchBox).css('display') == 'none') return;

                    if (_options.LoadingImageUrl != '' && $(_targetControl).val().length >= _options.MinCharLimit) {
                        $(_oneSearchBox).html('<img src="' + _options.LoadingImageUrl + '" />');
                    }

                    setTimeout(function () {
                        searchKeyword();
                    }, 500);
                });

                $(_targetControl).focus(function () {

                    if (parseInt(_oneSearchBox.css('width')) != getTotalWidthOfControl($(_targetControl))) {
                        _oneSearchBox.css('width', getTotalWidthOfControl($(_targetControl)));
                    }
                    if (parseInt(_oneSearchBox.css('top')) != getTotalHeightOfControl($(_targetControl))) {
                        _oneSearchBox.css('top', getTotalHeightOfControl($(_targetControl)));
                    }


                    if (_options.MultiSelect) {
                        if (_MultiSelectBox.find('a.agora-onesearch-multi-sel-item-close').length > 0) {
                            var _tempContMult = $('<div>')
                                .html($(_MultiSelectBox.html()));
                            $(_tempContMult).find('a.agora-onesearch-multi-sel-item-close').each(function () {
                                $(this).attr('onclick', 'javascript:$(\'#' + options.MultiSelectBoxId + ' #' + $(this).attr('id') + '\').trigger(\'click\')')
                            })

                            if (_options.MultiSelectShowHelpText) _options.HelpText = '<div style="padding:7px"><font style="color:red">You have already selected</font>' + ((_options.StickyMode) ? '<a class="CloseArea" href="javascript:void(0);" title="Click here to hide selected filters." onclick="$(\'#' + $(_targetControl).attr('id') + '_OneSearch' + '\').hide();">Close</a>' : '') + '<hr style="margin:0px 0px 7px 0px" />' + _tempContMult.html() + '</div>';
                            else {
                                if (_options.EnableCurrentLocation) {
                                    $(_tempContMult).append(getCurrentLocationObject());
                                }
                            }
                        } else {
                            _options.HelpText = '';
                            if (_options.EnableCurrentLocation) {
                                if ($(_oneSearchBox).find('[data-location-search]').length == 0)
                                    $(_oneSearchBox).append(getCurrentLocationObject());
                                $(_oneSearchBox).show();
                            }
                        }
                    }

                    if (_options.EnablePreList) {
                        searchKeyword();
                        $(_oneSearchBox).show();
                    } else if (!_options.MultiSelect && _options.EnableCurrentLocation) {
                        if ($(_oneSearchBox).find('[data-location-search]').length == 0)
                            $(_oneSearchBox).append(getCurrentLocationObject());
                        console.log(getCurrentLocationObject());
                        $(_oneSearchBox).show();
                    } else if (_options.HelpText != '' && $(_targetControl).val() == '') {
                        $(_oneSearchBox).html(_options.HelpText);

                        if (parseInt(_oneSearchBox.css('width')) != getTotalWidthOfControl($(_targetControl))) {
                            _oneSearchBox.css('width', getTotalWidthOfControl($(_targetControl)));
                        }
                        if (parseInt(_oneSearchBox.css('top')) != getTotalHeightOfControl($(_targetControl))) {
                            _oneSearchBox.css('top', getTotalHeightOfControl($(_targetControl)));
                        }

                        $(_oneSearchBox).show();
                    }
                });

                $(_targetControl).blur(function () {
                    if (_options.AutoSelectFirstItem && $(_targetControl).val().length > 0 && !_options.MultiSelect) {
                        setTimeout(function () {
                            var isManualSelect = $(_targetControl).data('is-manual-select');
                            if (typeof (isManualSelect) == 'undefined' || isManualSelect == false)
                                selectItem(0, true, true);
                            $(_targetControl).data('is-manual-select', false);
                        }, 50);
                    }
                    setTimeout(function () {
                        if (!_options.TestMode) {
                            $(_oneSearchBox).html('');
                            $(_oneSearchBox).hide();
                            if ($(_targetControl).val().length == 0) {
                                $(_oneSearchBox).parent().removeClass('is-dirty');
                            }

                        }
                        else if ($(_oneSearchBox).find('[data-location-search]').length > 0 && _options.TestMode) {
                            $(_oneSearchBox).html('');
                            $(_oneSearchBox).hide();
                            $(_oneSearchBox).parent().removeClass('is-dirty');
                        }
                        else if (_options.StickyMode && $(_oneSearchBox).find('div.agora-onesearch-multi-sel-item-cont').length == 0) {
                            $(_oneSearchBox).html('');
                            $(_oneSearchBox).hide();
                            $(_oneSearchBox).parent().removeClass('is-dirty');
                        }
                    }, 300);
                });

                searchKeyword();

                if (_options.AnimatePlaceholderText == true && $(_targetControl).val() == '') {
                    AnimatePlaceholderText($(_targetControl), '', 0);
                }
            }

            function getCurrentLocationObject() {
                if (_options.EnableCurrentLocation && (document.location.protocol.toLowerCase().indexOf('https') > -1 || document.location.hostname.indexOf('localhost') > -1)) {
                    return $('<a>')
                        .html('<i class="aga aga-location"></i>' + $(_targetControl).attr('EnableCurrentLocationLabel'))
                        .css('display', 'block')
                        .css('width', '100%')
                        .css('padding', '3px')
                        .css('color', 'red')
                        .attr('idx', -1)
                        .addClass('get-my-direction')
                        .attr('data-location-search', '')
                        .mouseover(function () { $(this).css('background-color:red'); $(this).addClass(_options.HighlightItemCss); })
                        .click(function () { searchNearby($(this).attr('idx')); })
                        .on('tap', function () { searchNearby($(this).attr('idx')); })
                        .mouseout(function () { $(this).removeClass(_options.HighlightItemCss); });
                }
                return null;
            }

            function clearNearby() {
                if (_isLocationSerachEnabled) {
                    $('input[type="hidden"][id="' + $(_targetControl).attr('id') + '_GPS_RLAT"]').val('');
                    $('input[type="hidden"][id="' + $(_targetControl).attr('id') + '_GPS_RLONG"]').val('');
                    $('input[type="hidden"][id="' + $(_targetControl).attr('id') + '_GPS_RDS"]').val('');
                    $('#draw_search').click();
                }
            }

            function searchNearby(idx) {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        $('input[type="hidden"][id="' + $(_targetControl).attr('id') + '_GPS_RLAT"]').val(position.coords.latitude);
                        $('input[type="hidden"][id="' + $(_targetControl).attr('id') + '_GPS_RLONG"]').val(position.coords.longitude);
                        $('input[type="hidden"][id="' + $(_targetControl).attr('id') + '_GPS_RDS"]').val(($(_targetControl).attr('DefaultSearchRadius') != null && $(_targetControl).attr('DefaultSearchRadius') != '0') ? $(_targetControl).attr('DefaultSearchRadius') : '5');
                        _isLocationSerachEnabled = true;
                        if (_options.OnSelect) _options.OnSelect({ "k": position.coords.latitude + '|' + position.coords.longitude, "n": "IDCLATITUDE|IDCLONGITUDE", "rt": "LOCATION" });
                        if (_options.OnSuccess) _options.OnSuccess();
                    })
                }
                selectItem(idx);
            }
            var previouslookuplabel=null;
            function searchKeyword(lookupLabel, afterSearch) {
                if (_lastSearchword == $(_targetControl).val() && !_options.EnablePreList && lookupLabel == null) return;
                 // If there already a request not yet completed then that need to stop/abort before staarting new one
                if (_request != null && previouslookuplabel == null)
                    _request.abort();
                if (lookupLabel != null)
                    previouslookuplabel = lookupLabel;
                else
                    previouslookuplabel = null;

                if ($(_targetControl).val().length < _options.MinCharLimit) _lastKeyword = ''; else _lastSearchword = $(_targetControl).val();

                if (lookupLabel == null && !_options.EnablePreList && $(_targetControl).val().length < _options.MinCharLimit) return;

                if (_options.AutoSelectFirstItem) {
                    $(_targetAutoControl).val('');
                    $(_targetControl).data('is-manual-select', false);
                }

                _searchParam = (($(_targetControl).val().length < _options.MinCharLimit) ? '' : $(_targetControl).val())
                _searchKeyword = (($(_targetControl).val().length < _options.MinCharLimit) ? '' : $(_targetControl).val().replace(/#/g, '%23')) + '&t=' + new Date().getTime()
                if (lookupLabel != null && lookupLabel.length > 0) {
                    _searchParam = _searchKeyword = 'LOOKUP_LABEL::' + lookupLabel;
                }

                _request = $.ajax({
                    type: 'POST',
                    url: _options.ServiceUrl + "?Keyword=" + _searchKeyword,
                    data: ({ "Keyword": _searchParam, "SearchMode": _options.SearchMode, "OneSearchName": _options.OneSearchName, "Region": _options.Region, "Locale": _options.Locale, "AdditionalWhere": $(_targetControl).attr('AdditionalWhere') }),
                    dataType: 'json',
                    success: function (data) {
                        if (lookupLabel != null && afterSearch != null) {
                            afterSearch(data);
                            return;
                        }
                        _resposeCache = data;
                        _highlightIdx = 0;
                        $(_oneSearchBox).html('');
                        if (data == undefined || data.length == 0) {
                            $(_oneSearchBox).hide();
                            return;
                        }

                        var _itemData = '';
                        var _field = '';
                        var _item = null;
                        var _categoryitem = '';
                        var _cateogoryname = '';
                       

                        for (i = 0; i < data.length; i++) {
                            _itemData = highlightKeyword(data[i].l, $(_targetControl).val());
                            _field = getFieldJson(_options.OneSearchDS, data[i].rt, data[i].n);

                            if (_field != null && _field.ItemTemplate != null && _field.ItemTemplate != '') {
                                _itemData = _field.ItemTemplate.replace('{$l}', highlightKeyword(data[i].l, $(_targetControl).val()));
                                _itemData = _itemData.replace('{$d}', data[i].d);
                            } else if (_field != null && _field.ItemTemplates.length > 0) {
                                for (j = 0; j < _field.ItemTemplates.length; j++) {
                                    if (_field.ItemTemplates[j].Locale == _options.Locale) {
                                        _itemData = _field.ItemTemplates[j].Template.replace('{$l}', highlightKeyword(data[i].l, $(_targetControl).val()));
                                        _itemData = _itemData.Template.replace('{$d}', data[i].d);
                                    }
                                }
                            }

                            _item = $('<a>')
                                .html(_itemData)
                                .css('display', 'block')
                                .css('width', '100%')
                                .css('padding', '3px')
                                .css('text-decoration', 'none')
                                .css('color', 'black')
                                .attr('idx', i)
                                .mouseover(function () { $(this).addClass(_options.HighlightItemCss); })
                                .mousedown(function () { $(_targetControl).data('is-manual-select', true); })
                                .click(function () { selectItem($(this).attr('idx')); })
                                .on('tap', function () { $(_targetControl).data('is-manual-select', true); selectItem($(this).attr('idx')); })
                                .mouseout(function () { $(this).removeClass(_options.HighlightItemCss); });

                            if (i == 0 && _options.AutoSelectFirstItem) {
                                autoSelectItem(i, false, true);
                            }
                            if (_options.EnableCategoryView) {
                                if (_cateogoryname != data[i].g) {
                                    _categoryitem = $('<div>').addClass('OneSearchBox-category-'+ data[i].g);
                                    _categoryitem.append ($('<span>').html(data[i].g));
                                    _cateogoryname = data[i].g;
                                }
                                _categoryitem.append(_item);
                                $(_oneSearchBox).append(_categoryitem);
                                if (i == 0 && $(_oneSearchBox)[i].className.includes('OneSearchBox-'))
                                    $(_oneSearchBox)[i].className = $(_oneSearchBox)[i].className.replace(/\bOneSearchBox-[A-Za-z]*\b/g, '');
                                $(_oneSearchBox).addClass('OneSearchBox-' + data[i].g);
                            }
                            else {
                                $(_oneSearchBox).append(_item);
                           }
                        }
                },
                    statusCode: {
                        404: function () {
                            console.log('Service (agoraOneSearch) not found!');
                        }
                    }
            });
        }

    function selectHighlightedItem() {
        if (_resposeCache == null || _resposeCache.length < (_highlightIdx - 1) || _highlightIdx <= 0) return;

        var _label = '';
        var _selectedValue = '';
        var _field = getFieldJson(_options.OneSearchDS, _resposeCache[_highlightIdx - 1].rt, _resposeCache[_highlightIdx - 1].n);
        if (_field != null && _field.ItemTemplate != '') {
            if (_field.Selector != undefined && _field.Selector != null && _field.Selector == 'k')
                _selectedValue = _resposeCache[_highlightIdx - 1].k;
            else
                _selectedValue = _resposeCache[_highlightIdx - 1].l;
        }
        _label = _resposeCache[_highlightIdx - 1].l;

        if (!_options.MultiSelect) {
            $(_targetControl).val(_label);
        } else {
            $(_targetControl).val('');
        }


        _lastKeyword = $(_targetControl).val();
        bindAssociateControl(_resposeCache[_highlightIdx - 1], _selectedValue);
        if (_options.AutoSelectFirstItem) autoSelectItem((_highlightIdx - 1));
        if (_options.OnSelect) _options.OnSelect(_resposeCache[_highlightIdx - 1]);
        _highlightIdx = 0;
        if (!_options.TestMode) $(_oneSearchBox).html('');
    }

    function selectItem(idx, noclear, autoSelect) {
        var _label = '';
        var _selectedValue = '';
        if (noclear == undefined || noclear == null) noclear = false;
        if (autoSelect == undefined || autoSelect == null) autoSelect = false;

        if (typeof (_resposeCache) == 'undefined' || _resposeCache == null || _resposeCache.length == 0) return;

        var _field = getFieldJson(_options.OneSearchDS, _resposeCache[idx].rt, _resposeCache[idx].n);
        if (_field != null && _field.ItemTemplate != '') {
            if (_field.Selector != undefined && _field.Selector != null && _field.Selector == 'k')
                _selectedValue = _resposeCache[idx].k;
            else
                _selectedValue = _resposeCache[idx].l;
        }
        _label = _resposeCache[idx].l;

        if (_label.includes('<span')) {
            _label = _label.replace(/<span[^>]*>.*?<\/span>/gi, '').trim();
        }
        if (autoSelect == true && !_label.toLowerCase().startsWith($(_targetControl).val().toLowerCase())) {
            $(_targetAutoControl).val('');
            return;
        }

        if (!_options.MultiSelect) {
            if (_field != null &&_field.SkipSelect != true) $(_targetControl).val(_label); else $(_targetControl).val('');
            if (_options.AutoSelectFirstItem) $(_targetAutoControl).val('');
        } else {
            $(_targetControl).val('');
            if (_options.AutoSelectFirstItem) $(_targetAutoControl).val('');
        }

        _lastKeyword = $(_targetControl).val();
        if (idx >= 0) clearNearby();
        if (_field != null &&_field.SkipSelect != true) bindAssociateControl(_resposeCache[idx], _selectedValue);
        if (_options.OnSelect) _options.OnSelect(_resposeCache[idx]);
        if (!_options.TestMode && !noclear) $(_oneSearchBox).html('');

        if (_options.MultiSelect) {
            if (!_options.EnablePreList) {
                setTimeout(function () { $(_targetControl).focus(); }, 200);
            }
        }
    }

    function autoSelectItem(idx) {
        var _label = '';
        var _selectedValue = '';
        if ($(_targetControl).val() == null || $(_targetControl).val() == '') return;
        if (typeof (_resposeCache) == 'undefined' || _resposeCache == null || _resposeCache.length == 0) return;
        var _field = getFieldJson(_options.OneSearchDS, _resposeCache[idx].rt, _resposeCache[idx].n);
        if (_field != null && _field.ItemTemplate != '') {
            if (_field.Selector != undefined && _field.Selector != null && _field.Selector == 'k')
                _selectedValue = _resposeCache[idx].k;
            else
                _selectedValue = _resposeCache[idx].l;
        }
        _label = _resposeCache[idx].l;

        if (_label.includes('<span')) {
            _label = _label.replace(/<span[^>]*>.*?<\/span>/gi, '').trim();
        }

        if (!_label.toLowerCase().replace(/\,/g, '').startsWith($(_targetControl).val().toLowerCase().replace(/\,/g, ''))) {
            $(_targetAutoControl).val('');
            return;
        }
       var regEx = new RegExp($(_targetControl).val(), "ig");
        $(_targetAutoControl).val(_label.replace(regEx, $(_targetControl).val()));

        _lastKeyword = $(_targetControl).val();
    }

    function reloadMultiSelectOnLoad() {
        if (!_options.MultiSelect) return;

        $('input[type="hidden"][id^="' + $(_targetControl).attr('id') + '"]').each(function () {
            if ($(this).val() != '') {
                var _item = {}; //[{ "k": "Charlotte", "l": "Charlotte, NC", "n": "CITY", "rt": "CMNCMN" }]
                var _itemValue = $(this).attr('id').split('_');
                _item.rt = _itemValue[_itemValue.length - 2];
                _item.n = _itemValue[_itemValue.length - 1];

                if ($(this).attr('data-label-lookup') == 'True') {
                    searchKeyword(_item.rt + '|' + _item.n + '::' + $(this).val(), function (resultJson) {
                        var _labels = '';
                        var _keys = ''; 
                        if (Array.isArray(resultJson)) {
                            _labels = resultJson.map(function (item) {
                                return item.l;
                            }).join(';');

                            _keys = resultJson.map(function (item) {
                                return item.k;
                            }).join(';'); 
                        }

                        bindAssociateControl(_item, _keys, true, _labels);
                        $(_targetControl).val('');
                    });
                }
                else {
                    bindAssociateControl(_item, $(this).val(), true);
                }
            }
        });
    }
    function reloadSingleSelectOnLoadForDatalookup() {
        if (_options.MultiSelect) return;

        const $hiddenInputs = $('input[type="hidden"][id^="' + $(_targetControl).attr('id') + '"]');

        $hiddenInputs.each(function () {
            const $input = $(this);
            const value = $input.val();

            // Proceed only if value is non-empty and data-label-lookup is True
            if (value && value.trim() !== '' && $input.attr('data-label-lookup') === 'True') {
                const _item = {};
                const _itemValue = $input.attr('id').split('_');
                _item.rt = _itemValue[_itemValue.length - 2];
                _item.n = _itemValue[_itemValue.length - 1];

                searchKeyword(_item.rt + '|' + _item.n + '::' + value, function (resultJson) {
                    if (Array.isArray(resultJson) && resultJson.length > 0) {
                        if (resultJson[0].l.includes('<span')) { resultJson[0].l = resultJson[0].l.replace(/<span[^>]*>.*?<\/span>/gi, '').trim(); }
                        const label = resultJson[0].l;
                        const key = resultJson[0].k;
                        bindAssociateControl(_item, key, true, label);
                    }
                });
            }
        });
    }

    function bindAssociateControl(item, value, initialLoad, labels) {
        if (!_options.MultiSelect) {
            const $hiddenInputs = $('input[type="hidden"][id^="' + $(_targetControl).attr('id') + '"]');
            const hasLabelLookup = $hiddenInputs.is('[data-label-lookup="True"]');

            if (item == null) return;

            if (hasLabelLookup && labels) {
                $(_targetControl).val(labels);
            }
            else
            {
                $('input[type="hidden"][id^="' + $(_targetControl).attr('id') + '"]').each(function () {
                    $(this).val('');
                });
                if (item == null) return;
                $('#' + $(_targetControl).attr('id') + '_' + item.rt + '_' + item.n).val(value);
            }
        } else {
            if (item == null) return;
            var _ctrlMultiField = $('#' + $(_targetControl).attr('id') + '_' + item.rt + '_' + item.n);

            var _valueItems = value.split(";");
            var _valueItemsCarrier = _valueItems;
            if (labels != null && labels != undefined) var _valueItems = labels.split(";");
            var _field = getFieldJson(_options.OneSearchDS, item.rt, item.n);

            for (i = 0; i < _valueItems.length && _field != null; i++) {
                if (_valueItems[i].length < 2) continue;
                if ((';' + _ctrlMultiField.val().toLowerCase() + ';').indexOf(';' + _valueItems[i].toLowerCase() + ';') == -1 || initialLoad) {
                    if (!initialLoad) _ctrlMultiField.val(_ctrlMultiField.val() + ';' + _valueItems[i]);

                    var _multiSelectItem = $('<div>')
                        .addClass('agora-onesearch-multi-sel-item-cont')
                        .attr('id', 'multiitem' + $(_targetControl).attr('id') + '_' + item.rt + '_' + item.n + _valueItems[i].replace(/\ /g, '_').replace(/\-/g, '_').replace(/[^A-z0-9]/g, '_'))
                        .append($('<a>')
                            .addClass('agora-onesearch-multi-sel-item-close')
                            .attr('title', 'Click here to hide this area filter.')
                            .attr('id', 'multiitem_close_' + $(_targetControl).attr('id') + '_' + item.rt + '_' + item.n + _valueItems[i].replace(/\ /g, '_').replace(/\-/g, '_').replace(/[^A-z0-9]/g, '_'))
                            .attr('val', _valueItemsCarrier[i])
                            .html('<i class="aga aga-close"></i>')
                            .click(function () {
                                removeFromMultiSelect($(this), item, $(this).attr('val'));
                            })
                        )
                        .append($('<a>')
                            .html(_field.MultiItemTemplate.replace('{$l}', (item != null && item.l != null) ? item.l : _valueItems[i]).replace('{$d}', (item != null && item.d != null) ? item.d : _valueItems[i]))
                        )

                    _MultiSelectBox.append(_multiSelectItem);
                }
            }

            if (!initialLoad && _options.OnMultiSelectRemove) _options.OnMultiSelectRemove();
        }
    }

    function hasMultiSelectedItems() {
        return (_options.MultiSelect && _MultiSelectBox.find('a.agora-onesearch-multi-sel-item-close').length > 0);
    }

    function removeFromMultiSelect(me, item, value) {
        var _ctrlMultiField = $('#' + $(_targetControl).attr('id') + '_' + item.rt + '_' + item.n);
        if (_ctrlMultiField.val().indexOf(';') != 0) _ctrlMultiField.val(';' + _ctrlMultiField.val());
        _ctrlMultiField.val(_ctrlMultiField.val().replace(';' + value, ''));

        //$('#multiitem' + $(_targetControl).attr('id') + '_' + item.rt + '_' + item.n + value.replace(/\ /g, '_').replace(/\-/g, '_')).remove();
        $(me).parent().remove();

        if (_ctrlMultiField.val() == "" || $(_oneSearchBox).find('div.agora-onesearch-multi-sel-item-cont').length == 0) {
            $(_oneSearchBox).html('');
            $(_oneSearchBox).hide();
        }

        if (_options.OnMultiSelectRemove) _options.OnMultiSelectRemove();
    }


    function highlightItem(direction) {
        _isOnArrowSelection = true;

        if (direction > 0) /*down*/ {
            if (_highlightIdx < $(_oneSearchBox).find('a').length) _highlightIdx++;
        }
        else /*up*/ {
            if (_highlightIdx > 1) _highlightIdx--;
        }
        $(_oneSearchBox).find('a').each(function () { $(this).removeClass(_options.HighlightItemCss); });
        $(_oneSearchBox).find((_options.EnableCategoryView) ? 'a[idx=' + _highlightIdx + ']' : 'a:nth-child(' + _highlightIdx + ')').addClass(_options.HighlightItemCss);
    }

    function getTotalWidthOfControl(object) {

        if (object == null || object.length == 0) {
            return 0;
        }

        var value = object.width();
        value += parseInt(object.css("padding-left"), 10) + parseInt(object.css("padding-right"), 10); //Total Padding Width
        //value += parseInt(object.css("margin-left"), 10) + parseInt(object.css("margin-right"), 10); //Total Margin Width
        value += parseInt(object.css("borderLeftWidth"), 10) + parseInt(object.css("borderRightWidth"), 10); //Total Border Width

        if (_options.ParentContainer != '') {
            value += object.offset().left;
        }

        return value;
    }

    function getTotalHeightOfControl(object) {

        if (object == null || object.length == 0) {
            return 0;
        }

        var value = object.height();
        value += parseInt(object.css("padding-top"), 10) + parseInt(object.css("padding-bottom"), 10); //Total Padding Width
        //value += parseInt(object.css("margin-top"), 10) + parseInt(object.css("margin-bottom"), 10); //Total Margin Width
        value += parseInt(object.css("borderTopWidth"), 10) + parseInt(object.css("borderBottomWidth"), 10); //Total Border Width
        value += object.position().top;

        if (_options.ParentContainer != '') {
            value += object.offset().top;
        }

        return value;
    }

    function getFieldJson(obj, rt, fieldName) {
        if (_itemTeplateCache[rt + '_' + fieldName] != null) return _itemTeplateCache[rt + '_' + fieldName];

        for (k = 0; k < obj.RecordTypes.length; k++) {
            for (j = 0; obj.RecordTypes[k].Name == rt && j < obj.RecordTypes[k].Fields.length; j++) {
                if (obj.RecordTypes[k].Fields[j].Name == fieldName) {
                    _itemTeplateCache[rt + '_' + fieldName] = obj.RecordTypes[k].Fields[j];
                    return obj.RecordTypes[k].Fields[j];
                }
            }
        }
        return null;
    }

    function preg_quote(str) {
        return (str + '').replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, "\\$1");
    }

    function highlightKeyword(str, keyword) {
        //return str.replace(new RegExp(preg_quote(to), 'gi'), by);

        return str.replace(new RegExp("(" + preg_quote(keyword) + ")", 'gi'), "<strong>$1</strong>");
    }
}
});
})(jQuery);

